import React from "react";
import { FormControl, InputLabel, Select, MenuItem } from "@mui/material";
import { TUTORIAL_JOURNEY_ANCHORS } from "../../../constants";

const humanizeKey = (key: string) =>
  key
    .replace(/([a-z])([A-Z])/g, "$1 $2")
    .replace(/\b\w/g, (char) => char.toUpperCase());

export interface StepAnchorSelectProps {
  tutorialType?: keyof typeof TUTORIAL_JOURNEY_ANCHORS;
  value: string;
  onChange: (anchor: string) => void;
  mb?: number;
  selectedAnchors?: string[];
}

export const StepAnchorSelect: React.FC<StepAnchorSelectProps> = ({
  tutorialType,
  value,
  onChange,
  mb = 2,
  selectedAnchors,
}) => {
  if (!tutorialType) return null;

  const anchorsForType = TUTORIAL_JOURNEY_ANCHORS[tutorialType];
  if (!anchorsForType) return null;

  const options = Object.keys(anchorsForType);

  const loweredSelectedAnchors =
    selectedAnchors?.map((a) => a.trim().toLowerCase()) || [];

  return (
    <FormControl fullWidth sx={{ mb }}>
      <InputLabel id="step-anchor-select-label">Anchor</InputLabel>
      <Select
        labelId="step-anchor-select-label"
        value={value}
        label="Anchor"
        onChange={(e) => onChange(e.target.value)}
      >
        {options.map((key) => (
          <MenuItem
            key={key}
            value={key}
            disabled={
              loweredSelectedAnchors.includes(key.trim().toLowerCase()) &&
              value.trim().toLowerCase() !== key.trim().toLowerCase()
            }
          >
            {humanizeKey(key)}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};
